// index/index.js
import { createRouter, createWebHistory } from 'vue-router';
import tracking from '@/services/tracking'
import LoginApp from '@/components/LoginApp.vue';
import LoginSSOCallback from '@/components/LoginSSOCallback.vue';
import Overview_Error from '@/components/Overview/Overview_Error.vue';
import Overview_Not_Found from '@/components/Overview/Overview_Not_Found.vue';
import Overview_Forbidden from '@/components/Overview/Overview_Forbidden.vue';
import Overview_Engagement from '@/components/Overview/Overview_Engagement.vue';
import VerifyEmail from '@/components/forms/VerifyEmail.vue';
import Form_Change_Password from '@/components/forms/Form_Change_Password.vue'
import Form_Password_Reset from '@/components/forms/Form_Password_Reset.vue';
import store from '@/store';
import Overview_List_Engage from '@/components/Overview_Lists/Overview_List_Engage.vue';
import Overview_List_Team from '@/components/Overview_Lists/Overview_List_Manage.vue';
import { COMPANY } from '@/constants';
import Overview_No_Tenants from '@/components/Overview/Overview_No_Tenants.vue';
import Overview_Survey from '@/components/Overview/Overview_Survey.vue';
import PortalPractice from '@/components/Portal/Portal_Overview.vue';
import ExternalModule from '@/components/External/ExternalModule.vue';
import ExternalPatientDetail from '@/components/External/ExternalPatientDetail.vue';
import Overview_List_Manage from '@/components/Overview_Lists/Overview_List_Manage.vue';
import Overview_List_Debug from '@/components/Overview_Lists/Overview_List_Debug.vue';
import Overview_TeamsMeeting from '@/components/Overview/Overview_TeamsMeeting.vue';
import PortalError from '@/components/Portal/Portal_Error.vue';
import Overview_TenantAdmin from '@/components/Overview_Lists/Overview_List_TenantAdmin.vue';
import HomePage from '@/components/HomePage.vue';
import AgentExplore from '@/components/Beta/AgentExplore.vue';
import MetricTest from '@/components/Beta/MetricTest.vue';
import ConstraintAnalysis from '@/components/Beta/ConstraintAnalysis.vue';
import Overview_List_Patient from "@/components/Overview_Lists/Overview_List_Patient.vue";
import Patient_Claims_Explorer from "@/components/Patient/Patient_Claims_Explorer.vue";
import Patient_Drawer_Page from "@/components/Patient_Drawer/Patient_Drawer_Page.vue";
import Overview_Admin_User from '@/components/Overview/Overview_Admin_User.vue';
import MetricAlertInstanceOverview from "@/components/Metric/Metric_Alert_Instance_Overview.vue";
import Overview_Entity from "@/components/Entity/Overview_Entity.vue";
import Overview_List_Insight from "@/components/Overview_Lists/Overview_List_Insight.vue";
import InsightsNew from "@/components/InsightsNew/InsightsNew.vue";
import CareManagement_Overview from "@/components/Care_Management/CareManagement_Overview.vue";
import Quality_Overview from "@/components/Quality/Quality_Overview.vue";
import Coding_Overview from "@/components/Coding/Coding_Overview.vue";
import { SUPPORT_ROUTES } from "@/components/Support/support_routes";
import OutreachView from "@/components/Outreach/OutreachView.vue";
import AgentTab from "@/components/Outreach/AgentTab.vue";
import CallTab from "@/components/Outreach/CallTab.vue";
import CampaignsTab from "@/components/Outreach/CampaignsTab.vue";
import ReportingTab from "@/components/Outreach/ReportingTab.vue";
import BetaView from "@/components/BetaView.vue";
import { canAccessRoute } from '@/utils/routeAccess';
import { canAccessFeature } from '@/utils/access';
import Overview_List_ETL_Utility from "@/components/Overview_Lists/Overview_List_ETL_Utility.vue";
import LeverageAnalysisTab from "@/components/Portfolio_Management/LeverageAnalysisTab.vue";
import EntityClassificationTab from "@/components/Portfolio_Management/EntityClassificationTab.vue";
import AttributionTab from "@/components/Portfolio_Management/AttributionTab.vue";
import CCLFReport from "@/components/External/CCLFReport/CCLFReport.vue";
import ConfigurablePage from "@/components/ConfigurablePage.vue";
import { FEATURES } from "@/constants/features";
import GrowthDashboard from "@/components/Growth/GrowthDashboard.vue";
import IntelligenceStudio from "@/components/Intelligence/IntelligenceStudio.vue";
import Rostering_Test from "@/components/Rostering/Rostering_Test.vue";
import PHM_Dashboard from "@/components/PHM/PHM_Dashboard.vue";
import PHM_AssessmentReport from "@/components/PHM/PHM_AssessmentReport.vue";


const routes = [
  { path: '/not-found', name: 'NotFound', component: Overview_Not_Found },
  { path: '/error', name: 'ErrorPage', component: Overview_Error },
  { path: '/forbidden', name: 'ForbiddenPage', component: Overview_Forbidden },
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: { requiresAuth: true, layout:'default' },
  },
  {
    path:'/debug',
    name:'Debug',
    component: Overview_List_Debug,
    meta:{
      canAccess: FEATURES.MODULE_DEBUG,
      requiresAuth: true,
      layout:'default'
    }
  },
  {
    path: '/growth',
    name: 'Growth',
    component: GrowthDashboard,
    meta: {
      canAccess: FEATURES.MODULE_GROWTH,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path:'/data',
    name:'Data',
    component: Overview_List_ETL_Utility,
    meta:{
      canAccess: FEATURES.MODULE_DATA,
      requiresAuth: true,
      layout:'default'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginApp,
    meta: { requiresAuth: false, layout:'default' },
  },
  {
    path: '/login/sso_callback',
    name: 'LoginSSOCallback',
    component: LoginSSOCallback,
    meta: { layout: 'bare' },
  },
  {
    path: '/account/email/verify/:verificationKey',
    component: VerifyEmail,
    props: true,
  },
  {
    path: '/account/password/change',
    name: 'ChangePassword',
    component: Form_Change_Password,
    meta: { requiresAuth: true },
  },
  {
    path: '/account/password/forgot',
    redirect: { name: 'Login' },
  },
  {
    path: '/account/password/reset/:verificationKey',
    component: Form_Password_Reset,
    props: true,
  },
  {
    path:'/entity/:entity_id/:tab?',
    component: Overview_Entity,
    name: 'Entity',
    props: true,
    meta: { requiresAuth: true, layout:'default'}
  },
  {
    path: '/caremanagement',
    redirect: '/caremanagement/patients',
    meta: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    path: '/caremanagement/patients',
    name: 'CareManagement-Patients',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Patients',
      selectedType: null,
      selectedId: null
    },
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/patients/:patientId',
    name: 'CareManagement-PatientDetail',
    component: CareManagement_Overview,
    props: route => ({
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Patients',
      selectedType: 'patient',
      selectedId: route.params.patientId
    }),
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/tasks',
    name: 'CareManagement-MyTasks',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'My Tasks',
      selectedType: null,
      selectedId: null
    },
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/tasks/:taskId',
    name: 'CareManagement-TaskDetail',
    component: CareManagement_Overview,
    props: route => ({
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'My Tasks',
      selectedType: 'task',
      selectedId: route.params.taskId
    }),
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/calendar',
    name: 'CareManagement-MyCalendar',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'My Calendar',
      selectedType: null,
      selectedId: null
    },
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/calendar/:taskId',
    name: 'CareManagement-CalendarDetail',
    component: CareManagement_Overview,
    props: route => ({
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'My Calendar',
      selectedType: 'task',
      selectedId: route.params.taskId
    }),
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/opportunities',
    name: 'CareManagement-Opportunities',
    component: CareManagement_Overview,
    props: { canAccess: FEATURES.MODULE_CARE_MANAGEMENT, activeTab: 'Opportunities', selectedType: null, selectedId: null },
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/opportunities/:opportunityId',
    name: 'CareManagement-OpportunityDetail',
    component: CareManagement_Overview,
    props: route => ({
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Opportunities',
      selectedType: 'opportunity',
      selectedId: route.params.opportunityId
    }),
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/operations',
    name: 'CareManagement-Operations',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Overview',
      selectedType: null,
      selectedId: null
    },
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/risk',
    name: 'CareManagement-Risk',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'AI Risk Score',
      selectedType: null,
      selectedId: null
    },
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/assignments',
    name: 'CareManagement-Assignments',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Assignments',
      selectedType: null,
      selectedId: null
    },
    meta: {requiresAuth: true, layout: 'default'}
  },
  {
    path: '/caremanagement/search-enroll',
    name: 'CareManagement-SearchEnroll',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Search & Enroll',
      selectedType: null,
      selectedId: null
    },
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/caremanagement/registry',
    name: 'CareManagement-Registry',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Registry',
      selectedType: null,
      selectedId: null
    },
    meta: { requiresAuth: true, canAccess: FEATURES.MODULE_CARE_MANAGEMENT, layout: 'default' }
  },
  {
    path: '/caremanagement/data-integration',
    name: 'CareManagement-DataIntegration',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Data Integration',
      selectedType: null,
      selectedId: null
    },
    meta: { requiresAuth: true, requiresSuperUser: true, layout: 'default' }
  },
  {
    path: '/caremanagement/provider-messaging',
    name: 'CareManagement-ProviderMessaging',
    component: CareManagement_Overview,
    props: {
      activeTab: 'Provider Messaging',
      selectedType: null,
      selectedId: null,
    },
    meta: { canAccess: FEATURES.MODULE_PROVIDER_MESSAGING, requiresAuth: true, layout: 'default' },
  },
  {
    path: '/caremanagement/utilization-management',
    name: 'CareManagement-UtilizationManagement',
    component: CareManagement_Overview,
    props: {
      canAccess: FEATURES.MODULE_CARE_MANAGEMENT,
      activeTab: 'Utilization Mgmt',
      selectedType: null,
      selectedId: null
    },
    meta: { requiresAuth: true, requiresSuperUser: true, layout: 'default' }
  },
  // Quality Routes
  {
    path: '/quality',
    redirect: '/quality/patients',
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/patients',
    name: 'Quality-Patients',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/patients/:patientId',
    name: 'Quality-PatientDetail',
    component: Quality_Overview,
    props: route => ({
      selectedPatientId: route.params.patientId
    }),
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/medication-adherence',
    name: 'Quality-MedicationAdherence',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/clinical-results',
    name: 'Quality-ClinicalResults',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/stars-performance',
    name: 'Quality-StarsPerformance',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/operations',
    name: 'Quality-Operations',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/trackers',
    name: 'Quality-Trackers',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/flat-file',
    name: 'Quality-FlatFile',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/assignments',
    name: 'Quality-Assignments',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/ecqm-facts',
    name: 'Quality-ECQMFacts',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/quality/extracted-data',
    name: 'Quality-ExtractedData',
    component: Quality_Overview,
    meta: {
      canAccess: FEATURES.MODULE_QUALITY,
      requiresAuth: true,
      layout: 'default'
    }
  },
  // PHM Routes
  {
    path: '/phm',
    redirect: '/phm/population-assessment',
    meta: {
      canAccess: FEATURES.MODULE_PHM_DASHBOARD,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/phm/population-assessment',
    name: 'PHM-PopulationAssessment',
    component: PHM_Dashboard,
    meta: {
      canAccess: FEATURES.MODULE_PHM_DASHBOARD,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/phm/data-integration',
    name: 'PHM-DataIntegration',
    component: PHM_Dashboard,
    meta: {
      canAccess: FEATURES.MODULE_PHM_DASHBOARD,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/phm/assessment-report',
    name: 'PHM-AssessmentReport',
    component: PHM_AssessmentReport,
    meta: {
      canAccess: FEATURES.MODULE_PHM_DASHBOARD,
      requiresAuth: true,
      layout: 'default'
    }
  },
  // Coding Routes
  {
    path: '/coding',
    redirect: '/coding/patients',
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/coding/patients',
    name: 'Coding-Patients',
    component: Coding_Overview,
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/coding/suspect-rules',
    name: 'Coding-SuspectRules',
    component: Coding_Overview,
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    // Formerly /coding/operations ("Operations", the v1 CDI reporting surface),
    // pulled from customers 2026-07-27 and rebuilt as the suspect-review pace
    // analysis. Opened to MODULE_CODING 2026-07-30 — same gate as Operations
    // V2, so it reaches Vytalize admins. Still labelled beta on the page.
    path: '/coding/summary',
    name: 'Coding-Summary',
    component: Coding_Overview,
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    // Legacy bookmarks. The v1 Operations surface is no longer customer-facing;
    // send everyone to V2 (the supported report) rather than to the superuser
    // Summary route, which would Forbidden a customer.
    path: '/coding/operations',
    redirect: '/coding/operations-v2'
  },
  {
    path: '/coding/operations-v2',
    name: 'Coding-Operations-V2',
    component: Coding_Overview,
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/coding/assignments',
    name: 'Coding-Assignments',
    component: Coding_Overview,
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/coding/console',
    name: 'Coding-Console',
    component: Coding_Overview,
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/coding/economics',
    name: 'Coding-Economics',
    component: Coding_Overview,
    meta: {
      canAccess: FEATURES.MODULE_CODING,
      requiresAuth: true,
      layout: 'default'
    }
  },
  ...SUPPORT_ROUTES,
  // Redirects for old routes
  { path: '/outreach', redirect: '/beta/outreach' },
  { path: '/outreach/:path(.*)', redirect: to => `/beta/outreach/${to.params.path}` },
  // Beta section
  {
    path: '/beta',
    component: BetaView,
    redirect: '/beta/leverage-analysis',
    meta: {
      requiresAuth: true,
      layout: 'default'
    },
    children: [
      {
        path: 'agent',
        name: 'Beta-Agent',
        component: AgentExplore,
        meta: {
          canAccess: FEATURES.MODULE_ADMIN,
          requiresAuth: true,
          layout: 'default'
        }
      },
      {
        path: 'metric-test',
        name: 'Beta-MetricTest',
        component: MetricTest,
        meta: {
          canAccess: FEATURES.MODULE_ADMIN,
          requiresAuth: true,
          layout: 'default'
        }
      },
      {
        path: 'leverage-analysis',
        name: 'Beta-LeverageAnalysis',
        component: LeverageAnalysisTab,
        meta: {
          canAccess: FEATURES.MODULE_PORTFOLIO,
          requiresAuth: true,
          layout: 'default'
        }
      },
      {
        path: 'entity-classification',
        name: 'Beta-EntityClassification',
        component: EntityClassificationTab,
        meta: {
          canAccess: FEATURES.MODULE_PORTFOLIO,
          requiresAuth: true,
          layout: 'default'
        }
      },
      {
        path: 'attribution',
        name: 'Beta-Attribution',
        component: AttributionTab,
        meta: {
          canAccess: FEATURES.MODULE_PORTFOLIO,
          requiresAuth: true,
          layout: 'default'
        }
      },
      {
        path: 'cclf-report',
        name: 'Beta-CCLFReport',
        component: CCLFReport,
        meta: {
          canAccess: FEATURES.MODULE_PORTFOLIO,
          requiresAuth: true,
          requiresSuperUser: true,
          layout: 'default'
        }
      },
      {
        path: 'outreach',
        component: OutreachView,
        redirect: '/beta/outreach/call',
        meta: {
          canAccess: FEATURES.MODULE_OUTREACH,
          requiresAuth: true,
          layout: 'default'
        },
        children: [
          {
            path: 'agents',
            name: 'Beta-Outreach-Agents',
            component: AgentTab,
            meta: { requiresAuth: true, layout: 'default' }
          },
          {
            path: 'call',
            name: 'Beta-Outreach-Call',
            component: CallTab,
            meta: { requiresAuth: true, layout: 'default' }
          },
          {
            path: 'campaigns',
            name: 'Beta-Outreach-Campaigns',
            component: CampaignsTab,
            meta: { requiresAuth: true, layout: 'default' }
          },
          {
            path: 'reporting',
            name: 'Beta-Outreach-Reporting',
            component: ReportingTab,
            meta: { requiresAuth: true, layout: 'default' }
          },
        ]
      },
      {
        path: 'rostering-test',
        name: 'Beta-RosteringTest',
        component: Rostering_Test,
        meta: {
          requiresAuth: true,
          layout: 'default'
        }
      },
      {
        path: 'growth',
        name: 'Beta-Growth',
        component: GrowthDashboard,
        meta: {
          canAccess: FEATURES.MODULE_GROWTH,
          requiresAuth: true,
          layout: 'default'
        }
      },
      // /beta/support/* retired (items 7+8) -> redirect to the consolidated
      // /support/* workspace. The catch-all preserves deep links like
      // /beta/support/requirements/1856 with one rule (static 'support' ranks
      // above the param route, so bare /beta/support hits the explicit redirect).
      { path: 'support', redirect: '/support/service-desk' },
      { path: 'support/:pathMatch(.*)*', redirect: to => `/support/${to.params.pathMatch.join('/')}` },
      {
        path: 'intelligence-studio',
        name: 'Beta-IntelligenceStudio',
        component: IntelligenceStudio,
        meta: { requiresAuth: true, requiresSuperUser: true, layout: 'default' }
      },
      {
        path: 'constraint-analysis',
        name: 'Beta-ConstraintAnalysis',
        component: ConstraintAnalysis,
        meta: { requiresAuth: true, requiresSuperUser: true, layout: 'default' }
      },
    ]
  },
  {
    path: '/beta/personal-analyst',
    redirect: '/manage',
  },
  {
    // Defined before '/portal/:entityid' so "console" isn't matched as an entity id.
    path: '/portal/console',
    component: PortalPractice,
    name: 'PortalConsole',
    meta: {
      canAccess: FEATURES.MODULE_PORTAL,
      requiresAuth: true,
      layout:'portal'
    },
  },
  {
    // The deprecated unified worklist needed its own path once bare '/portal'
    // started landing on the Console (2026-08-01). Same ordering constraint as
    // '/portal/console' — must precede '/portal/:entityid' or "worklist" is
    // matched as an entity id. Entity-scoped worklists still use
    // '/portal/:entityid' and are unaffected.
    path: '/portal/worklist',
    component: PortalPractice,
    name: 'PortalWorklist',
    meta: {
      canAccess: FEATURES.MODULE_PORTAL,
      requiresAuth: true,
      layout:'portal'
    },
  },
  {
    path: '/portal/:entityid',
    component: PortalPractice,
    name: 'PortalEntity',
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_PORTAL,
      requiresAuth: true,
      layout:'portal'
    },
  },
  {
    path: '/portal',
    component: PortalPractice,
    name: 'PortalOverview',
    meta: {
      canAccess: FEATURES.MODULE_PORTAL,
      requiresAuth: true,
      layout:'portal'
    },
  },
  {
    path: '/portal/error/:errorType?/:requestedPracticeId?',
    component: PortalError,
    name: 'PortalError',
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_PORTAL,
      requiresAuth: true,
      layout:'portal'
    },
  },
  {
    path: '/external/patient/:patientIdentifier',
    component: ExternalPatientDetail,
    name: 'ExternalPatientDetail',
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_EXTERNAL,
      requiresAuth: true,
      layout: 'external',
    },
  },
  {
    path: '/external/:entityid',
    component: ExternalModule,
    name: 'ExternalEntity',
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_EXTERNAL,
      requiresAuth: true,
      layout: 'external',
    },
  },
  {
    path: '/external',
    component: ExternalModule,
    name: 'ExternalOverview',
    meta: {
      canAccess: FEATURES.MODULE_EXTERNAL,
      requiresAuth: true,
      layout: 'external',
    },
  },
  {
    path: '/metricalertinstance/:alertInstanceId',
    component: MetricAlertInstanceOverview,
    name: 'MetricAlertInstance',
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_METRIC_ALERTS,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    path: '/tenantadmin',
    component: Overview_TenantAdmin,
    meta: {
      canAccess: FEATURES.MODULE_ADMIN,
      requiresAuth: true,
      layout:'default'
    },
    children: [
      { path: '', redirect: { name: 'AdminIAMConsole' } },
      { path: 'iam-console', name: 'AdminIAMConsole', meta: { adminTab: 'IAM Console' } },
      { path: 'task-admin', name: 'AdminTaskAdmin', meta: { adminTab: 'Opportunity/Task Admin' } },
      { path: 'infotag-manager', name: 'AdminInfoTagManager', meta: { adminTab: 'InfoTag Manager' } },
      { path: 'entity-configuration', name: 'AdminEntityConfiguration', meta: { adminTab: 'Entity Configuration' } },
      { path: 'llm-suggestion-types', name: 'AdminLLMSuggestionTypes', meta: { adminTab: 'LLM Suggestion Types' } },
      { path: 'care-management', name: 'AdminCareManagement', meta: { adminTab: 'Care Management' } },
      { path: 'workflow-configuration', name: 'AdminWorkflowConfiguration', meta: { adminTab: 'Workflow Configuration' } },
      { path: 'performance-domains-metrics', name: 'AdminPerformanceDomainsMetrics', meta: { adminTab: 'Performance Domains & Metrics' } },
      { path: 'alert-management', name: 'AdminAlertManagement', meta: { adminTab: 'Alert Management' } },
      { path: 'page-configuration', name: 'AdminPageConfiguration', meta: { adminTab: 'Page Configuration' } },
      { path: 'telephony', name: 'AdminTelephony', meta: { adminTab: 'Telephony' } },
      { path: 'metric-studio', name: 'AdminMetricStudio', meta: { adminTab: 'Performance Domains & Metrics' } },
      { path: 'metric-studio/:metricId', name: 'AdminMetricDetail', meta: { adminTab: 'Performance Domains & Metrics' } },


    ],
  },
  {
    path: '/engagement/:engagement_id',
    component: Overview_Engagement,
    name: 'Engagement',
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_ENGAGEMENT,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    path: '/team',
    component: Overview_List_Team,
    name: 'Teams',
    meta: {
      canAccess: FEATURES.MODULE_TEAM,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    path: '/engage',
    name: 'Engage',
    component: Overview_List_Engage,
    meta: {
      canAccess: FEATURES.MODULE_ENGAGE,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    // Transform — prototype. Renders entirely from fixtures in
    // components/Transform/transformFixtures.js; no API, no tenant data. Superuser-only
    // while it is a prototype so it cannot reach a customer by a feature-flag accident.
    path: '/transform',
    name: 'Transform',
    component: () => import('@/components/Transform/TransformBoard.vue'),
    meta: {
      canAccess: FEATURES.MODULE_ENGAGE,
      requiresSuperUser: true,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    path: '/manage',
    name: 'Manage',
    component: Overview_List_Manage,
    meta:{
      canAccess: FEATURES.MODULE_MANAGE,
      requiresAuth: true,
      layout:'default'
    }
  },
  {
    path: '/current_user',
    name: 'Current User',
    component: ConfigurablePage,
    props: { pageIdentifier: 'user_overview' },
    meta: {
      requiresAuth: true,
      layout:'default',
    },
  },
  {
    path: '/phone-settings',
    name: 'Phone Settings',
    component: () => import('@/components/PhoneSettings.vue'),
    meta: {
      canAccess: FEATURES.COMPONENT_TELEHEALTH_PHONE,
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    path: '/voicemails',
    name: 'Voicemail Inbox',
    component: () => import('@/components/Voicemails.vue'),
    meta: {
      canAccess: FEATURES.COMPONENT_TELEHEALTH_PHONE,
      requiresAuth: true,
      layout: 'default',
    },
  },
  // === /insight routes → InsightsNew (composable metrics) ===
  {
    name: 'Insight - Tenant - Overall',
    path: '/insight',
    component: InsightsNew,
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Impact Analytics - Study Builder',
    path: '/insight/impact-analytics/study-builder',
    component: InsightsNew,
    props: { showImpactAnalytics: true, impactTab: 'studies' },
    meta: {
      canAccess: FEATURES.MODULE_PORTFOLIO,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Impact Analytics - Study Wizard',
    path: '/insight/impact-analytics/study-wizard',
    component: () => import('@/components/Impact_Analytics/StudyWizard.vue'),
    props: route => ({ studyId: route.query.study || null }),
    meta: {
      canAccess: FEATURES.MODULE_PORTFOLIO,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Impact Analytics - Datasets',
    path: '/insight/impact-analytics/populations',
    component: InsightsNew,
    props: { showImpactAnalytics: true, impactTab: 'populations' },
    meta: {
      canAccess: FEATURES.MODULE_PORTFOLIO,
      requiresAuth: true,
      layout: 'default'
    },
  },
  { path: '/insight/impact-analytics', redirect: '/insight/impact-analytics/study-builder' },
  { path: '/beta/impact-analytics', redirect: '/insight/impact-analytics/study-builder' },
  {
    name: 'Insight - Tenant - Attribution',
    path: '/insight/attribution',
    component: Overview_List_Insight,
    props: { performanceDomainId: -1 },
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Entity - Attribution',
    path: '/insight/attribution/:entityIds(\\d+)+',
    component: Overview_List_Insight,
    props: route => ({
      performanceDomainId: -1,
      entityIds: route.params.entityIds.map(Number)
    }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Tenant - Domain',
    path: '/insight/domain/:performanceDomainId',
    component: InsightsNew,
    props: route => ({ performanceDomainId: Number(route.params.performanceDomainId) }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Tenant - Metric',
    path: '/insight/metric/:metricId',
    component: InsightsNew,
    props: route => ({ metricId: Number(route.params.metricId) }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Entity - Overall',
    path: '/insight/:entityIds(\\d+)+',
    component: InsightsNew,
    props: route => ({
      entityIds: route.params.entityIds.map(Number)
    }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Entity - Domain',
    path: '/insight/domain/:performanceDomainId(\\d+)/:entityIds(\\d+)+',
    component: InsightsNew,
    props: route => ({
      performanceDomainId: Number(route.params.performanceDomainId),
      entityIds: route.params.entityIds.map(Number)
    }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Entity - Metric',
    path: '/insight/metric/:metricId(\\d+)/:entityIds(\\d+)+',
    component: InsightsNew,
    props: route => ({
      metricId: Number(route.params.metricId),
      entityIds: route.params.entityIds.map(Number)
    }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  // Legacy /insight/performancedomain paths still work (for bookmarks/links)
  {
    name: 'Insight - Tenant - Performance Domain (legacy path)',
    path: '/insight/performancedomain/:performanceDomainId',
    component: InsightsNew,
    props: route => ({ performanceDomainId: Number(route.params.performanceDomainId) }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'Insight - Entity - Performance Domain (legacy path)',
    path: '/insight/performancedomain/:performanceDomainId(\\d+)/:entityIds(\\d+)+',
    component: InsightsNew,
    props: route => ({
      performanceDomainId: Number(route.params.performanceDomainId),
      entityIds: route.params.entityIds.map(Number)
    }),
    meta: {
      canAccess: FEATURES.MODULE_INSIGHTS,
      requiresAuth: true,
      layout: 'default'
    },
  },
  // === /insightsnew → /insight redirects (legacy URLs preserved for bookmarks) ===
  { path: '/insightsnew', redirect: '/insight' },
  { path: '/insightsnew/builder', redirect: '/insight' },
  { path: '/insightsnew/domain/:performanceDomainId', redirect: to => `/insight/domain/${to.params.performanceDomainId}` },
  { path: '/insightsnew/metric/:metricId', redirect: to => `/insight/metric/${to.params.metricId}` },
  { path: '/insightsnew/:entityIds(\\d+)+', redirect: to => `/insight/${to.params.entityIds.join('/')}` },
  { path: '/insightsnew/domain/:performanceDomainId(\\d+)/:entityIds(\\d+)+', redirect: to => `/insight/domain/${to.params.performanceDomainId}/${to.params.entityIds.join('/')}` },
  { path: '/insightsnew/metric/:metricId(\\d+)/:entityIds(\\d+)+', redirect: to => `/insight/metric/${to.params.metricId}/${to.params.entityIds.join('/')}` },
  { path: '/insightsnew/performancedomain/:performanceDomainId', redirect: to => `/insight/domain/${to.params.performanceDomainId}` },
  { path: '/insightsnew/performancedomain/:performanceDomainId(\\d+)/:entityIds(\\d+)+', redirect: to => `/insight/domain/${to.params.performanceDomainId}/${to.params.entityIds.join('/')}` },
  {
    name: 'ProviderNetwork',
    path: '/provider/network/:npi?',
    component: () => import('@/components/Overview_Lists/Overview_Provider_Network.vue'),
    props: true,
    meta: {
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    name: 'PatientList',
    path: '/patients',
    component: Overview_List_Patient,
    meta: {
      canAccess: FEATURES.MODULE_PATIENT,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    name: 'PatientDetail',
    path: '/patients/:patientIdentifier',
    component: Overview_List_Patient,
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_PATIENT,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    name: 'PatientClaims',
    path: '/patients/:patientIdentifier/claims',
    component: Patient_Claims_Explorer,
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_PATIENT,
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    name: 'PatientDrawerPage',
    path: '/patients/:patientIdentifier/drawer',
    component: Patient_Drawer_Page,
    props: true,
    meta: {
      requiresAuth: true,
      layout: 'default',
    },
  },
  {
    name: 'Survey',
    path: '/surveys/:survey_id',
    component: Overview_Survey,
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_SURVEYS,
      requiresAuth: true,
      layout:'default'
    },
  },
  {
    name:'TeamsMeeting',
    path:'/microsoftteams/meetings/:meetingId/appuser/:appuserId/',
    component: Overview_TeamsMeeting,
    props: true,
    meta:{
      requiresAuth: true,
      layout:'default'
    }
  },
  { path: '/portfolio', redirect: '/beta/leverage-analysis' },
  {
    path: '/admin/user/:id',
    name: 'User Admin',
    component: Overview_Admin_User,
    props: true,
    meta: {
      canAccess: FEATURES.MODULE_ADMIN,
      requiresAuth: true,
      layout: 'default'
    },
  },
  {
    name: 'No Tenants',
    path: '/no-tenants',
    component: Overview_No_Tenants,
    meta: { requiresAuth: true },
  },
  {
    path: '/work/:token',
    name: 'AsyncEngagementForm',
    component: () => import('@/components/Outreach/AsyncEngagement/AsyncEngagementForm.vue'),
    meta: {
      requiresAuth: false,
      layout: 'bare'
    }
  },
  {
    path: '/video/join/:token',
    name: 'PatientWaitingRoom',
    component: () => import('@/components/Care_Management/Widgets/PatientEngagement/PatientWaitingRoom.vue'),
    meta:{
      requiresAuth: false,
      layout: 'bare'
    }
  },
 {
    path: '/work/clinicalengagement/:workId',
    name: 'ClinicalEngagement',
    component: () => import('@/components/Care_Management/Widgets/PatientEngagement/ClinicalEngagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/work/clinicalengagement/new/:opportunityId/:taskId',
    name: 'ClinicalEngagementNew',
    component: () => import('@/components/Care_Management/Widgets/PatientEngagement/ClinicalEngagement.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/voice-calling-test',
    name: 'VoiceCallingTest',
    component: () => import('@/components/Voice_Calling_Test/TestCall.vue'),
    meta: {
      requiresAuth: true,
      layout: 'default'
    }
  },
  {
    path: '/integration-sandbox',
    name: 'IntegrationSandbox',
    component: () => import('@/components/IntegrationSandbox.vue'),
    meta: {
      requiresAuth: false,
      layout: 'bare',
    },
  },
  // Catch-all: redirect unmatched routes to Not Found
  { path: '/:pathMatch(.*)*', redirect: '/not-found' }
];

const index = createRouter({
  history: createWebHistory(),
  routes,
});

// Be very careful about editing this flow as it is precisely calibrated to prevent unnecessary
// redirection to the login page. This router guard runs before App.Vue has a chance to
// fetchUser, which is why fetchUser is called here instead of there.
index.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isLoginPage = to.name === 'Login';
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const availableEntities = store.getters['entity/availableEntities'];

  document.title = `${to.name || ''} | ${COMPANY.NAME}`;

  // Bare layout routes skip all auth/entity/tenant checks
  if (to.meta.layout === 'bare') {
    return next();
  }

  if (!isAuthenticated) {
    try {
      const user = await store.dispatch('auth/fetchUser');
      if (!user) {
        // if no user is logged in

        if (requiresAuth) {
          // Redirect to login page if the route requires authentication.
          // Save the intended destination so commonLogin() restores it after login —
          // afterEach won't fire for a blocked navigation, so we set it here.
          localStorage.setItem('last_visited_route', to.fullPath);
          return next({ name: 'Login' });
        } else {
          // Otherwise, proceed to the page that doesn't require any authentication
          return next();
        }
      }

      // Non-critical UI enhancement (profile notification badge) — don't block
      // navigation on it.
      store.dispatch('auth/fetchUnreadMessageCount');
    } catch (error) {
      // if there is an error while fetching the user send them back to the login page
      if (isLoginPage) {
        return next(); // avoid infinite redirect
      } else {
        // Preserve the intended destination before redirecting to login
        localStorage.setItem('last_visited_route', to.fullPath);
        return next({ name: 'Login' });
      }
    }
  }

  if (availableEntities.length === 0) {
    await store.dispatch('entity/fetchAvailableEntities');
  }

  // Deaconess/IHCI SRA #4 (90-day password rotation): if the backend flagged
  // this user's password as expired, force them to the change-password screen
  // before anything else. This is a UX head start — HasTenantRole is the real
  // enforcement boundary and 403s every other API call regardless. Exempt the
  // change-password route itself (or this would infinite-redirect) and Login
  // (an expired-but-unauthenticated visit shouldn't be affected here).
  if (store.getters['auth/passwordExpired'] && to.name !== 'ChangePassword' && to.name !== 'Login') {
    return next({ name: 'ChangePassword' });
  }

  // Curana portal users land on External instead of Portal. Runs BEFORE
  // canAccessRoute so portal users hitting `/` or any non-external route
  // get redirected to External instead of bouncing to Forbidden.
  const isExternalOnlyUser = store.getters['tenant/isExternalOnly'];
  if (isExternalOnlyUser && to.meta.layout !== 'external') {
    const entities = store.getters['entity/availableEntities'];
    if (entities.length > 0) {
      const default_entity_id = store.getters['entity/current_entity_id'];
      return next({
        name: 'ExternalEntity',
        params: { entityid: default_entity_id },
      });
    }
  }

  if (!canAccessRoute(to)) {
    if (to.name === 'ForbiddenPage') {
      return next();
    }
    return next({ name: 'ForbiddenPage' });
  }

  const availableTenants = store.getters['tenant/availableTenants'];
  const isNoTenantsPage = to.name === 'No Tenants';
  // If the user has no tenants, redirect to the No Tenants page
  if (
    availableTenants.length === 0 &&
    !isNoTenantsPage
  ) {
    return next({
      name: 'No Tenants'
    });
  }

  if (to.meta.layout === 'external') {
    await store.dispatch('entity/fetchAvailableEntities');
    const entities = JSON.parse(JSON.stringify(store.getters['entity/availableEntities']));
    if (to.name === 'ExternalOverview' && entities.length > 0) {
      const default_entity_id = store.getters['entity/current_entity_id'];
      return next({
        name: 'ExternalEntity',
        params: { entityid: default_entity_id },
      });
    }
  }

  if (to.meta.layout === 'portal'){
    await store.dispatch('entity/fetchAvailableEntities');
    const entities = JSON.parse(JSON.stringify(store.getters['entity/availableEntities']));

    if(entities.length > 0){
      if(to.name ==='PortalEntity' && !to.params.entityid){
        const default_entity_id = store.getters['entity/current_entity_id']
        return next({
          name: 'PortalEntity',
          params: {
            entityid: default_entity_id,
          }
        })
      }
    }

    if(to.name === 'PortalEntity') {
      const hasAccess = entities.some(entity => String(entity.entity_id) === String(to.params.entityid));
      if (!hasAccess) {
        return next({
          name: 'PortalError',
          params: {
            errorType: 'practice_access_denied',
            requestedEntityId: to.params.entityid,
          }
        });
      }
    }
  }

  return next();
});


index.afterEach((to, from) => {
  const path = to.fullPath;
  // Store the last visited route in local storage to redirect on login
  // Excludes the login page
  if (!path.includes('/login') && !path.includes('/account/password/')) {
    localStorage.setItem('last_visited_route', to.fullPath);
  }

  // Track page views for analytics
  window.__currentRoute = to.name
  tracking.track('page_view', {
    routeName: to.name,
    routePath: to.path,
    routeParams: to.params,
    fromRoute: from.name,
    fromPath: from.path,
  })
});

export default index;
